import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M16 0C24.8125 0 32 7.1875 32 16C32 24.875 24.8125 32 16 32C7.125 32 0 24.875 0 16C0 7.1875 7.125 0 16 0ZM16 30C23.6875 30 30 23.75 30 16C30 8.3125 23.6875 2 16 2C8.25 2 2 8.3125 2 16C2 23.75 8.25 30 16 30ZM20 22C20.5 22 21 22.5 21 23C21 23.5625 20.5 24 20 24H12C11.4375 24 11 23.5625 11 23C11 22.5 11.4375 22 12 22H15V10.875L13.5 11.875C13.0625 12.1875 12.4375 12.0625 12.125 11.5625C11.8125 11.125 11.9375 10.5 12.4375 10.1875L15.4375 8.1875C15.75 8 16.125 8 16.4375 8.125C16.75 8.3125 17 8.6875 17 9V22H20Z'],
  name: 'uiCircle1',
  oldName: 'falCircle1'
} as IconDefinition
